import * as tslib_1 from "tslib";
// Given that the sponsor
// has had the bill sent already, is sending a payment notification allowed?
export function isNotificationAllowed(sponsor) {
    if (sponsor.shouldPay == 0)
        return false;
    if (sponsor.numNotificationsSent >= 2)
        return false;
    var lastSentOn = new Date(sponsor.notificationSentOn ? sponsor.notificationSentOn : sponsor.billSentOn).valueOf();
    var now = Date.now();
    var daysSinceLastReminder = (now - lastSentOn) / 1000 / 3600 / 24;
    var notificationThresholdDays = sponsor.notificationSentOn ? 21 : 35;
    return daysSinceLastReminder >= notificationThresholdDays;
}
export function isInvitationAllowed(sponsor) {
    if (!sponsor.invitedOn)
        return true;
    var now = Date.now();
    var lastInvitedOn = new Date(sponsor.invitedOn).valueOf();
    var daysSinceLastInvite = (now - lastInvitedOn) / 1000 / 3600 / 24;
    return daysSinceLastInvite >= 21;
}
export function getQueryStringArgs() {
    var e_1, _a;
    var args = {};
    try {
        for (var _b = tslib_1.__values(location.search.substr(1).split(/&/g)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var arg = _c.value;
            var parts = arg.split(/=/, 2);
            args[parts[0]] = parts[1] ? decodeURIComponent(parts[1].replace(/\+/g, " ")) : "";
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return args;
}



//////////////////
// WEBPACK FOOTER
// ./app/ts/common.ts
// module id = 12
// module chunks = 0